import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import {
  Box,
  Button,
  ButtonGroup,
  ComponentMultiStyleConfig,
  Flex,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";

export type CMFrameButtonPopupSearchConditionProps = {
  /**
   * 検索条件選択用の別コンポーネントを受け取り、条件として表示する。
   */
  children: ReactNode;

  labelSubmit?: string;
  labelClear?: string;

  /**
   * クリアボタンの表示制御 trueの場合にクリアボタン非表示
   */
  hideClearButton?: boolean;

  /**
   * 検索条件で選択された値を呼び出し元に返却
   * @param selectedValue
   */
  onSubmit: () => void;

  /**
   * 選択済みの検索条件がクリアされたことを呼び出し元に返却
   * @param selectedValue
   */
  onClear?: () => void;
} & ComponentStyleProps;

/**
 * 検索条件フレームのコンポーネント
 *
 * コンポーネントを囲む枠は呼び出し元のpopoverで見えるようになる。
 */
export const CMFrameButtonPopupSearchCondition = ({
  children,
  labelSubmit,
  labelClear,
  hideClearButton = false,
  onSubmit,
  onClear,

  sx,
  ...rest
}: CMFrameButtonPopupSearchConditionProps) => {
  const styles = useMultiStyleConfig(
    "CMFrameButtonPopupSearchConditionStyles",
    {},
  );

  return (
    <Flex {...rest} sx={{ ...styles.container, ...sx }}>
      <Box sx={styles.childContainer}>
        <Box sx={styles.children}>{children}</Box>
        <ButtonGroup sx={styles.buttonGroup}>
          <Button onClick={onSubmit} sx={styles.submitButton}>
            <Text sx={styles.labelSubmit}>{labelSubmit}</Text>
          </Button>
          {hideClearButton ? null : (
            <Button onClick={onClear} sx={styles.clearButton}>
              <Text sx={styles.labelClear}>{labelClear}</Text>
            </Button>
          )}
        </ButtonGroup>
      </Box>
    </Flex>
  );
};

export const CMFrameButtonPopupSearchConditionStyles: ComponentMultiStyleConfig =
  {
    parts: [
      "container",
      "childContainer",
      "children",
      "buttonGroup",
      "submitButton",
      "labelSubmit",
      "clearButton",
      "labelClear",
    ],
    baseStyle: {
      container: { bg: "white" },
      childContainer: {},
      children: {
        display: "flex",
        flexFlow: "column nowrap",
      },
      buttonGroup: {
        mt: "12px",
      },
      submitButton: {
        bg: "teal.500",
        color: "white",
        h: "24px",
        maxW: "200px",
        minW: "52px",
        fontSize: "16px",
      },
      labelSubmit: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
      clearButton: {
        bg: "gray.200",
        color: "gray.700",
        h: "24px",
        maxW: "200px",
        minW: "52px",
        fontSize: "16px",
      },
      labelClear: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
    },
  };
